import { z } from 'zod';
export const SignedUrlCacheSchema = z.object({
    dateCreated: z.iso.datetime(),
    expirationDate: z.iso.datetime(),
    expiresAt: z.number().int(),
    s3Key: z.string(),
    signedUrl: z.url(),
});
